<script>
import ExportIcon from "@/icons/ExportIcon.vue";
import apiClient from "@/api/api-client";
import { getUsers } from "@/api/users";

export default {
  name: "VerifiedFilesReportList",
  components: { ExportIcon },
  data() {
    return {
      verifiedFilesDate: null,
      selectedVerifier: null,
      verifiedFiles: [],
      loading: false,
      users: [],
      total_duration: 0,
      total: 0,
      page: 1,
      limit: 20,
    };
  },
  computed: {
    domain() {
      return window.domain;
    },
  },
  async created() {
    await this.getVerifiedFiles();
    this.users = (await getUsers({ role: "verifier" })) || [];
  },
  methods: {
    async getVerifiedFiles() {
      this.loading = true;
      try {
        let params = {
          verifier_id: this.selectedVerifier,
          page: this.page,
          limit: this.limit,
        };
        if (this.verifiedFilesDate && this.verifiedFilesDate.length > 0) {
          params.start_date = this.verifiedFilesDate[0];
          params.stop_date = this.verifiedFilesDate[1];
        }
        const response = await apiClient.get("/export/verifier_files", {
          params,
        });
        if (response && response.data) {
          this.verifiedFiles = response.data.data || [];
        }
        if (response && response.data && response.data.totals) {
          this.total = response.data.totals.count;
          this.total_duration = response.data.totals.duration_str;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    changeFilterVerifiedFiles() {
      this.page = 1;
      this.getVerifiedFiles();
    },
    downloadFile(filename, fileUrl) {
      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async downloadReport(endpoint, params = {}) {
      this.loading = true;
      try {
        const data = await apiClient.post(endpoint, params);

        if (data && data.data && data.data.output_path) {
          const fileUrl = `${this.domain}${data.data.output_path}`;
          this.downloadFile(data.data.file_name, fileUrl);
        } else {
          alert("Не успешно");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async downloadMarkedFiles() {
      const params =
        this.verifiedFilesDate &&
        this.verifiedFilesDate[0] &&
        this.verifiedFilesDate[1]
          ? {
              start_date: this.verifiedFilesDate[0],
              stop_date: this.verifiedFilesDate[1],
              ...(this.selectedVerifier && {
                verifier_id: this.selectedVerifier,
              }),
            }
          : this.selectedVerifier
          ? { verifier_id: this.selectedVerifier }
          : {};

      await this.downloadReport("/export/verifier_files", params);
    },
    handleChangePage(page) {
      this.page = page;
      this.getVerifiedFiles();
    },
    trimMilliseconds(dateTimeStr) {
      if (!dateTimeStr) {
        return "";
      }
      return dateTimeStr.split(".")[0];
    },
  },
};
</script>

<template>
  <div class="mng-page flex flex-col h-full w-full">
    <div class="mng-page__header flex-shrink-0">
      <div class="mng-page__title-row">
        <h1 class="mng-page__title">Верифицированные файлы · {{ total }}</h1>
        <div class="flex items-center mt-1">
          <div class="text-gray-500">Общая длительность:</div>
          <div class="ml-1.5">
            <el-tag round>{{ total_duration }}</el-tag>
          </div>
        </div>
      </div>
      <div class="mng-page__filters">
        <div class="flex flex-wrap items-center justify-end gap-3">
          <el-date-picker
            v-model="verifiedFilesDate"
            value-format="YYYY-MM-DD"
            type="daterange"
            placeholder="Дата"
            style="max-width: 200px; margin-right: 10px"
            @change="changeFilterVerifiedFiles"
          ></el-date-picker>
          <el-select
            v-model="selectedVerifier"
            clearable
            filterable
            placeholder="Верификатор"
            style="width: 200px; margin-right: 10px"
            @change="changeFilterVerifiedFiles"
          >
            <el-option
              v-for="user in users"
              :key="user._id"
              :value="user._id"
              :label="`${user.first_name} ${user.last_name}`"
            ></el-option>
          </el-select>
          <el-button
            @click="downloadMarkedFiles"
            :disabled="loading"
            type="success"
            plain
            class="download_button"
          >
            <export-icon></export-icon>
            Скачать xlsx</el-button
          >
        </div>
      </div>
    </div>

    <main
      class="mng-page__body flex-1 min-h-0 flex flex-col overflow-hidden"
      style="padding: 20px 26px"
    >
      <el-table
        :data="verifiedFiles"
        v-loading="loading"
        border
        stripe
        height="100%"
        style="width: 100%; overflow-y: auto"
      >
        <el-table-column
          type="index"
          label="№"
          width="90"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column prop="_id" label="ID" width="240"></el-table-column>
        <el-table-column
          prop="topic"
          label="Имя батча"
          min-width="200"
        ></el-table-column>
        <el-table-column
          prop="filename"
          label="Имя файла"
          min-width="240"
        ></el-table-column>
        <el-table-column
          prop="duration_utterances"
          label="Длительность фрагментов"
          min-width="240"
        ></el-table-column>
        <el-table-column prop="lang" label="Язык" width="150"></el-table-column>
        <el-table-column
          prop="annotator_finish"
          label="Дата завершения разметки"
          min-width="240"
        >
          <template #default="scope">
            {{ trimMilliseconds(scope.row.annotator_finish) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="display_name_annotator"
          label="Аннотатор"
          min-width="240"
        ></el-table-column>
        <el-table-column
          prop="verification_finish"
          label="	Дата завершения верификации"
          min-width="270"
        >
          <template #default="scope">
            {{ trimMilliseconds(scope.row.verification_finish) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="display_name_verifier"
          label="Верификатор"
          min-width="240"
        ></el-table-column>
      </el-table>
      <div class="mt-3 flex justify-center">
        <el-pagination
          v-if="total > 20"
          background
          layout="pager"
          :total="total"
          :current-page="page"
          @update:current-page="handleChangePage"
          :page-size="limit"
        />
      </div>
    </main>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/manage-page.scss";
</style>
